import Divider from '@mui/material/Divider';
import { useTheme } from '@mui/material';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import SvgIcon from '@mui/material/SvgIcon';
import Button from '@mui/material/Button';
import { TCustomTheme } from '@mgm/common/theme';
import { useCustomTheme } from '@mgm/common/hooks/useCustomTheme';
import { BaseDrawer, BaseDrawerTitle } from '@mgm/common/components/base';
import { useTranslation } from 'react-i18next';
import { useAppDispatch, useAppSelector } from '../hooks/useAppStore';
import { getIsOpenDiscordNav } from '../store/help/selectors';
import { helpActions } from '../store/help/slice';
import appLogo from '../assets/appLogo.png';
import discordLogo from '../assets/discord.png';
import { ReactComponent as ArrowsIcon } from '../static/icons/ic_arrow.svg';
import { DISCORD_LINK } from '../../config';
import { commonActions } from '../store/common/slice';

const JoinDiscord = () => {
  const isOpenDiscordNav = useAppSelector(getIsOpenDiscordNav);
  const theme = useTheme() as TCustomTheme;
  const dispatch = useAppDispatch();
  const { t } = useTranslation('common');

  const { isMobile } = useCustomTheme(theme);

  const handleClose = () => {
    dispatch(helpActions.setIsOpenDiscordNav(false));
  };

  const openDiscord = () => {
    window.open(DISCORD_LINK, '_blank');
  };

  const onCloseDrawer = () => {
    dispatch(commonActions.setToggleDrawer(false));
  };

  return (
    <BaseDrawer
      open={isOpenDiscordNav}
      drawerProps={{
        anchor: 'right',
        width: isMobile ? 'auto' : 600,
        variant: 'persistent',
      }}
      onCloseDrawer={onCloseDrawer}
    >
      <BaseDrawerTitle
        title={t('joinManageMateCommunityOnDiscord')}
        handleClose={handleClose}
      />
      <Divider sx={{ borderStyle: 'dashed' }} />
      <Box
        paddingRight={isMobile ? 2 : 5}
        paddingLeft={isMobile ? 2 : 5}
        paddingTop={3}
        component="form"
        onSubmit={(e) => {
          e.preventDefault();
        }}
      >
        <Typography variant="body1">
          {t('weAreExcited')}
        </Typography>
        <Box mt={6} display="flex" justifyContent="space-between" alignItems="center">
          <img src={appLogo} alt="logo" width="120" />
          <SvgIcon
            sx={{
              color: '#A855F7',
              fontSize: '100px',
            }}
            component={ArrowsIcon}
            inheritViewBox
          />
          <img src={discordLogo} width="100" alt="discord logo" />
        </Box>
        <Box pt={4}>
          {t('byJoiningOurDiscord')}
          {' '}
          <br />
          <Box px={2} py={2} component="ul" sx={{ listStyleType: 'disc', pl: 2 }}>
            <Box component="li" mb={2}>
              <strong>{t('latestUpdates')}</strong>
              {' '}
              {t('beTheFirstToKnowAbout')}
            </Box>
            <Box component="li" mb={2}>
              <strong>{t('directSupport')}</strong>
              {' '}
              {t('getYourQuestionsAnswered')}
            </Box>
            <Box component="li" mb={2}>
              <strong>{t('vipAccess')}</strong>
              {' '}
              {t('enjoyExclusiveContent')}
            </Box>
            <Box component="li" mb={2}>
              <strong>{t('networkingOpportunities')}</strong>
              {' '}
              {t('connectWithOtherManageMateUsers')}
            </Box>
          </Box>
          {t('joiningIsSimple')}
        </Box>
        <Box pt={2}>
          <Button onClick={openDiscord}>
            {t('joinOurDiscordCommunity')}
          </Button>
        </Box>
      </Box>
    </BaseDrawer>
  );
};

export {
  JoinDiscord,
};
